<template>
  <section
    id="pricing-plan"
  >
    <!-- title text and switch button -->
    

    <div class="text-center">
      <h1 class="mt-5">
        Plan Seçenekleri /
        <span class="text-primary">Fiyatlandırma</span>
      </h1>
      <p class="mb-2 pb-75">
        Tüm planlar, ürününüzü güçlendirecek 40'tan fazla gelişmiş araç ve özellik içerir. İhtiyaçlarınıza en uygun planı seçin.
      </p>
      <div class="d-flex align-items-center justify-content-center mb-5 pb-50">
        <h6 class="mr-1 mb-0">
          Aylık
        </h6>
        <b-form-checkbox
          id="priceSwitch"
          v-model="status"
          name="price-switch"
          value="annually"
          unchecked-value="monthly"
          switch
          @input="tooglePlan"
        />
        <h6 class="ml-50 mb-0">
          Yıllık
        </h6>
      </div>
    </div>
    <!--/ title text and switch button -->
    <!-- pricing plan cards -->
    <b-row class="pricing-card">
      <b-col
        offset-sm-2
        sm="10"
        md="12"
        offset-lg="2"
        lg="10"
        class="mx-auto"
      >
        <b-row>
          <b-col md="4" v-for="(plan, index) in plans" :key="index">
            <b-card
              align="center"
              :class="{'border border-primary': plan.id==active_id}"
            >
              <div
                class="pricing-badge position-absolute"
                v-if="index === 1"
              >
                <b-badge
                  variant="light-primary"
                  pill
                >
                  Popüler
                </b-badge>
              </div>
              <!-- img -->
              <b-img
                :src="require(`@/assets/images/svg/plan${index+1}.svg`)"
                :class="index === 0 ? 'mb-2 mt-5' : index === 1 ? 'mt-2 mb-1' : 'mb-2'"
                alt="basic svg img"
              />
              <!--/ img -->
              <h3>{{ plan.name }}</h3>
              <b-card-text>
                {{ plan.description }}
              </b-card-text>

              <!-- annual plan -->
              <div class="annual-plan">
                <div class="plan-price mt-2">
                  <span class="pricing-basic-value font-weight-bolder text-primary">{{ monthlyPlanShow ? priceFormat(plan.price_monthly):priceFormat(plan.price_annual) }}</span>
                  <sub class="pricing-duration text-body font-medium-1 font-weight-bold"> / aylık</sub>
                </div>
                <small
                  v-show="!monthlyPlanShow"
                  class="annual-pricing text-muted"
                >{{ yearPrice(plan.price_annual)  }} / yıllık</small>
              </div>
              <!--/ annual plan -->

              <!-- plan benefit -->
              <b-list-group class="list-group-circle text-left">
                <b-list-group-item
                  v-for="(feature,index) in plan.features_category[0].features"
                  :key="index"
                  class="d-flex justify-content-between align-items-center"
                >
                  {{ feature.feature_name }} <b>{{ valueFormat(feature) }} </b>
                </b-list-group-item>
              </b-list-group>
              <!--/ plan benefit -->
               <transition-group name="fade" tag="div">
                <b-list-group
                    v-if="detailPlan"
                    v-for="(category, index) in plan.features_category.slice(1)"
                    :key="category.title"
                    class="list-group-circle text-left mt-2"
                >
                    <b class="text-primary">{{ category.title }}</b>
                    <b-list-group-item
                    v-for="(feature, idx) in category.features"
                    :key="idx"
                    class="d-flex justify-content-between align-items-center"
                    >
                    {{ feature.feature_name }} <b>{{ valueFormat(feature) }} </b>
                    </b-list-group-item>
                </b-list-group>
                </transition-group>

                <!-- buttons -->
                <div v-if="customer_id">
                    <b-button
                        v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                        block
                        class="mt-2"
                        variant="outline-success"
                        v-if="plan.id==active_id"
                    >
                        Seçili Plan
                    </b-button>
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        block
                        class="mt-2"
                        variant="primary"
                        @click="setPackage(plan.id)"
                        v-else
                    >
                        Plan Seç
                    </b-button>
                </div>

            </b-card>
          </b-col>
          
        </b-row>
      </b-col>
    </b-row>

    <div class="d-flex align-items-center justify-content-center mb-5 pb-50">
      <b-button class="m-auto" :variant="detailPlan ? 'warning' : 'primary'" @click="detailPlan = !detailPlan">
            Detayları Karşılaştır
        <feather-icon icon="ChevronUpIcon" size="16" v-if="detailPlan" />
        <feather-icon icon="ChevronDownIcon" size="16" v-else />   
      </b-button>
    </div>
    
  </section>
</template>

<script>
import {
  BFormCheckbox, BRow, BCol, BCard, BImg, BCardText, BListGroup, BListGroupItem, BButton, BBadge,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
/* eslint-disable global-require */
export default {
  components: {
    BFormCheckbox,
    BButton,
    BCardText,
    BRow,
    BCol,
    BCard,
    BBadge,
    BImg,
    BListGroup,
    BListGroupItem,
  },
  directives: {
    Ripple,
  },
  props: {
    plans: {
        type: Array,
        default: []
    },
    active_id:{
        type:Number,
        default:0
    },
    customer_id:{
        type: [Number, String], // hem number hem string kabul etsin
        default:null
    }
},
  data() {
    return {
      status: 'monthly',
      monthlyPlanShow: true,
      featureData:[],
      detailPlan: false,
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
    tooglePlan() {
      if (this.status === 'monthly') {
        this.monthlyPlanShow = true
      } else {
        this.monthlyPlanShow = false
      }
    },
    
    yearPrice(price) {
        return this.priceFormat(parseInt(price, 10) * 12);
    },
    isEmpty(value) {
        return value === null || value === undefined || value === '';
    },
    valueFormat(feature) {
        if (feature.type === 'day') {
            return `${feature.feature_value} Gün`
        }

        if (feature.type === 'boolean') {
            return feature.feature_value==1 ? 'Var' : 'Yok'
        }

        // Sınırsız kontrolü
        if ((feature.id === 6 || feature.id === 12) && this.isEmpty(feature.feature_value)) {
            return 'Sınırsız'
        }
        // Sınırsız kontrolü
        if ((feature.id === 1 || feature.id === 17) && this.isEmpty(feature.feature_value)) {
            return 'Ücretsiz'
        }

        // Sınırsız kontrolü
        if (feature.id === 14) {
            if (this.isEmpty(feature.feature_value)) {
                return 'Sınırsız'
            }else{
                return 'Son ' + feature.feature_value + ' Yıl'
            }
        }

        return feature.feature_value
    },
    
    async setPackage(packageid) {

        try {
            const now = new Date();
            const year = now.getFullYear();
            const month = now.getMonth() + 1; // getMonth() 0-based döner
            const formattedDate = `${year}-${String(month).padStart(2, '0')}-01`;
            const response = await this.$http.post('/manage/set-package', {
                id: this.customer_id,
                package: packageid,
                date: formattedDate
            });
            
            if (response.data.success) {
                // Paket bilgilerini yenile
                this.$emit('update:plans')
                
                // Başarı mesajı göster
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Başarılı!',
                        text: `Paket ${packageid} başarıyla ayarlandı.`,
                        variant: 'success',
                    },
                });
            } else {
                this.$toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Uyarı!',
                        text: response.data.message,
                        variant: 'danger',
                    },
                });
            }
            
        } catch (error) {
            console.error('Paket ayarlanırken hata:', error);
            
            this.$toast({
                component: ToastificationContent,
                props: {
                    title: 'Hata!',
                    text: 'Paket ayarlanırken hata oluştu.',
                    variant: 'danger',
                },
            });
        }
    }

  },
}
/* eslint-disable global-require */
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
